<template>
<div id="info24">
    <div class="info24-wrapper">
        <section>
            <article>
                <h2 class="caption">ヤギッシュの使いかた</h2>
            </article>
        </section>
        <section class="info-cream">
            <ul class="content-wrapper flex">
                <li class="index-title"><a href="#info01" class="step-h2">履歴書をつくる</a>
                    <ul class="index-list">
                        <li class="index-item"><a href="#info01-01">ログイン方法</a></li>
                        <li class="index-item"><a href="#info01-02">基本の使いかた</a></li>
                        <li class="index-item"><a href="#info01-03">入力した情報の保存</a></li>
                        <li class="index-item"><a href="#info01-04">サーバーへの自動保存</a></li>
                        <li class="index-item"><a href="#info01-05">データのバックアップ作成と復元（引き継ぎ）</a></li>
                        <li class="index-item"><a href="#info01-06">入力途中で履歴書の種類を変更する方法</a></li>
                        <li class="index-item"><a href="#info01-07">推奨環境</a></li>
                    </ul>
                </li>
                <li class="index-title"><a href="#info02" class="step-h2">PDF保存方法</a>
                    <ul class="index-list">
                        <li class="index-item"><a href="#info02-01">スマホにPDFをダウンロード保存する方法</a></li>
                        <li class="index-item"><a href="#info02-02">PDFをメールで送信</a></li>
                    </ul>
                </li>
                <li class="index-title"><a tabindex="-1" class="step-h2">各種サービス</a>
                    <ul class="index-list">
                        <li class="index-item index-outlink"><a href="https://www.yagish.jp/service/pdfeprint_manual/" target="_blank">コンビニ印刷サービス</a></li>
                        <li class="index-item index-outlink"><a href="https://www.yagish.jp/service/quickemail_manual/" target="_blank">ヤギのメール便</a></li>
                        <li class="index-item index-outlink"><a href="https://www.yagish.jp/service/quickmail_manual/" target="_blank">ヤギの宅配便</a></li>
                        <li class="index-item index-outlink"><a href="https://www.yagish.jp/service/fontservice_manual/" target="_blank">フォント変更</a></li>
                        <!--<li class="index-item index-outlink"><a href="" target="_blank">ヤギオファー</a></li>-->
                    </ul>
                </li>
                <li class="index-title"><a href="#info03" class="step-h2">紹介動画</a>
                    <ul class="index-list">
                        <li class="index-item"><a href="#info03-01">ヤギッシュの使いかた</a></li>
                        <li class="index-item"><a href="#info03-02">コンビニ印刷の仕方</a></li>
                        <li class="index-item"><a href="#info03-03">ヤギオファーについて</a></li>
                    </ul>
                </li>
            </ul>
        </section>

        <!--履歴書をつくる-->
        <section id="info01" class="step-box">
            <div class="content-wrapper">
                <h2 class="step-h2">履歴書をつくる</h2>

                <h3 id="info01-01" class="step-h3">ログイン方法</h3>
                <ul class="step-list">
                    <li class="step-item">
                        <p class="step-lead">履歴書を選択する</p>
                        <p class="step-txt">メニューバー右上の「ログイン」から、ログインページに遷移してください。</p>
                        <img src="/static/renew2_img/info01-01.png" alt="メニューバー右上の「ログイン」から、ログインページに遷移してください。"
                            class="step-img">
                    </li>
                    <li class="step-item">
                        <p class="step-lead">会員登録・ログイン</p>
                        <p class="step-txt">① メールアドレスで登録する→メールアドレスを入力して「送信する」押下：メールアドレス認証<br>
                            ② 他のサービスIDを利用して登録する：Google/AppleID<br>
                            ③ メールに登録リンクを送る→「メールでリンクを送る」を押下<br>
                            ※アプリではメールアドレス認証は行っておりません。アプリでもログイン・パスワードログインでのログインは可能です。</p>
                        <img src="/static/renew2_img/info01-02.png" alt="会員登録・ログイン" class="step-img">
                    </li>
                </ul>

                <h3 id="info01-02" class="step-h3">基本の使いかた</h3>
                <ul class="step-list">
                    <li class="step-item">
                        <p class="step-lead">履歴書を選択する</p>
                        <p class="step-txt">トップページの「この履歴書でつくる」でテンプレートを選択し、「入力をはじめる」ボタンをタップします。</p>
                        <img src="/static/renew2_img/info01-0201.png" alt="履歴書を選択する" class="step-img">
                    </li>
                    <li class="step-item">
                        <p class="step-lead">必要事項を入力する①〜⑤</p>
                        <p class="step-txt">
                            ① プロフィール<br>
                            ② 住所<br>
                            ③ 連絡先<br>
                            ④ 証明写真：「写真をアップロードする」をタップすると、カメラで撮影するか、写真フォルダからデータを選択するかが表示されます。<br>
                            ⑤ 学歴：年齢から自動で計算してくれるので、西暦・和暦を調べる必要もありません。
                        </p>
                        <img src="/static/renew2_img/info01-0202.png" alt="必要事項を入力する①〜⑤" class="step-img">
                    </li>
                    <li class="step-item">
                        <p class="step-lead">必要事項を入力する⑥〜⑩</p>
                        <p class="step-txt">
                            ⑥ 職歴<br>
                            ⑦ 免許・資格<br>
                            ⑧ 志望動機<br>
                            ⑨ 本人希望欄<br>
                            ⑩ 作成日<br>
                            「自動入力」や「例文から追加」の緑色のボタンをタップすると、テンプレート等が表示される便利な機能があるので活用してください。
                        </p>
                        <img src="/static/renew2_img/info01-0203.png" alt="必要事項を入力する⑥〜⑩" class="step-img">
                    </li>
                    <li class="step-item">
                        <p class="step-lead">履歴書を確認する⑪</p>
                        <p class="step-txt">
                            ⑪ 確認<br>
                            作成している履歴書の内容を確認することができます。修正する場合は、プレビューの修正欄をクリックまたはステップを戻ることで修正することができます。
                        </p>
                        <img src="/static/renew2_img/info01-0204.png" alt="履歴書を確認する⑪" class="step-img">
                    </li>
                    <li class="step-item">
                        <p class="step-lead">履歴書作成お疲れさまでした！</p>
                        <p class="step-txt">
                            ⑫ 完了<br>
                            ログインすると完成したデータを保存できます。「ダウンロードする」ボタンをタップすると、PDF化された履歴書が表示されます。
                        </p>
                        <img src="/static/renew2_img/info01-0205.png"
                            alt="ログインすると完成したデータを保存できます。「ダウンロードする」ボタンをタップすると、PDF化された履歴書が表示されます。" class="step-img">
                    </li>
                </ul>

                <h3 id="info01-03" class="step-h3">入力した情報の保存</h3>
                <p class="step-txt">
                    入力した情報はご利用の端末のブラウザ（SafariやChromeなど）の履歴に保存され、ブラウザを閉じても再度サイトにアクセスした際に続きを入力できるようになっています。<br><span
                        class="red-note">共用パソコン(ネットカフェや学校など複数の人が利用するパソコン)などでご利用いただく場合、パソコン内に残ったデータを他の人に見られてしまう可能性があります。yagishでは、サービスをご利用いただいた後にデータを削除することを推奨しております。
                    </span></p>
                <a href="/account/delete" class="step-link">データ・アカウントの削除</a>
                <p class="step-txt">また、マイページ ＞「その他の設定」 ＞ 「ブラウザのデータを削除する」からでもブラウザの履歴を削除できます。<br><br>
                    ・ブラウザの入力履歴はサーバーに保存されないため、その端末を使用している人しか見ることはできません。<br>
                    ・会員登録を行うと、ブラウザの履歴とは別にサーバーへ情報の保存ができるようになります。他の端末に情報を引き継いだり、データを繰り返し使うときにおすすめです。</p>

                <h3 id="info01-04" class="step-h3">サーバーへの自動保存<span>※ログイン時のみ</span></h3>
                <p class="step-txt">"必ず「自動バックアップ」にする必要があります。※自動バックアップの方法は、テンプレートの最後にある「完了」を押下すると「完了ページ」にサービスが並びます。どれか一つ選択すると自動バックアップになります。バックアップを作成しないと次回ログイン時にバックアップを復元することができません。"</p>

                <h3 id="info01-05" class="step-h3">データのバックアップ作成と復元（引き継ぎ）</h3>
                <p class="step-txt">マイページ ＞ 旧マイページ ＞ 「この履歴書を選択」から引き継ぎたいバックアップの「この履歴書を選択」をタップします。</p>
                <img src="/static/renew_img/img_info05.png" alt="マイページ＞旧マイページ＞「この履歴書を選択」から引き継ぎたいバックアップの「この履歴書を選択」をタップします。" class="step-img">
                <p class="step-txt">ページ下の「復元する」ボタンをタップすると読み込まれます。</p>
                <img src="/static/renew_img/img_info06.png" alt="ページ下の「復元する」ボタンをタップすると読み込まれます。" class="step-img">

                <h3 id="info01-06" class="step-h3">入力途中で履歴書の種類を変更する方法</h3>
                <p class="step-txt">
                    入力途中で履歴書の種類を変えた場合、同じ項目であればそのまま内容が引き継がれます。代わりに、履歴書ごとに別々の内容を保存することができないようになっています。<br>もしデータを保存しておきたい場合は、自動バックアップを操作し、「マイページ
                    > 旧マイページ > あなたの履歴データ」から必要なときにその内容を復元してご使用ください。</p>
                <img src="/static/renew2_img/info01-0601.png" alt="入力途中で履歴書の種類を変更する方法" class="step-img">
                <img src="/static/renew2_img/info01-0602.png" alt="入力途中で履歴書の種類を変更する方法" class="step-img">

                <h3 id="info01-07" class="step-h3">推奨環境</h3>
                <p class="step-txt">推奨環境でのご利用をお願いいたします。<br>
                    また、iOS端末をお使いの方は、必ずsafariアプリからsafariのブラウザでアクセスしてください。<br><br>
                    Googleにログインできないケース：<br>
                    ① iOS端末でChromeをお使いの場合、Googleにログインできないことがありますので、『safari』をご利用ください。<br>
                    ② LINEやGmailなどからYagishのURLをクリックしてアクセスしている場合、ブラウザがSafariでないケースがあります。そのため、<span
                        class="red-note">iOS端末をお使いの方は、必ずsafariアプリからsafariのブラウザでアクセスしてください。</span><br><br>

                    Androidスマートフォン<br>
                    OS: 8.0.0以降、ブラウザ: GoogleChrome<br><br>

                    iPhone<br>
                    OS: 11.3以降、ブラウザ: Safari<br><br>

                    Windows<br>
                    OS: Windows10、ブラウザ: GoogleChrome<br><br>

                    Mac<br>
                    OS: High Sierra、ブラウザ: GoogleChrome</p>
            </div>
        </section>

        <!--PDF保存方法-->
        <section id="info02" class="step-box">
            <div class="content-wrapper">
                <h2 class="step-h2">PDF保存方法</h2>

                <h3 id="info02-01" class="step-h3">スマホにPDFをダウンロード保存する方法<br><span>iPhoneからダウンロード・保存する場合</span></h3>
                <ul class="step-list">
                    <li class="step-item">
                        <p class="step-lead">シェアボタンをタップ</p>
                        <p class="step-txt">
                            「端末に保存」ボタンをタップし、履歴書のページが表示されたことを確認してください。Safariのメニューバーが表示されたら、シェアボタンアイコンをタップします。</p>
                        <img src="/static/renew_img/img_info-step07.png" alt="シェアボタンをタップ" class="step-img">
                    </li>
                    <li class="step-item">
                        <p class="step-lead">ファイルに保存をタップ</p>
                        <p class="step-txt">メニューが表示されるので、「ファイルに保存」をタップします。</p>
                        <img src="/static/renew_img/img_info-step08.png" alt="①の部分をタップすると、ファイル名が編集できます。"
                            class="step-img">
                    </li>
                    <li class="step-item">
                        <p class="step-lead">ファイル名をつけ保存する</p>
                        <p class="step-txt">①の部分をタップすると、ファイル名が編集できます。<br>
                            ② 保存先を「このiphone内」にします。<br>
                            ③ 右上の「保存」をタップして保存完了です。<br>
                            ※iCloudに保存したい方は「iCloud Drive」を選択ください。ほか、ダウンロード済のアプリ（Dropbox、Pagesなど）に保存したい場合はそのアプリを選択します。
                        </p>
                        <img src="/static/renew_img/img_info-step09.png" alt="ファイル名をつけ保存する" class="step-img">
                    </li>
                </ul>

                <h3 id="info02-02" class="step-h3">PDFをメールで送信</h3>
                <p class="step-txt">作成したPDFを、会員登録した自分のメールアドレスに送信することができます。<br>
                    履歴書の入力ページを最後の「完了」まで進み「PDFをメールで送る」ボタンをタップしてください。</p>
                <img src="/static/renew2_img/info01-0205.png" alt="PDFをメールで送信" class="step-img">
            </div>
        </section>

        <!--紹介動画-->
        <section id="info03" class="step-box">
            <div class="content-wrapper">
                <h2 class="step-h2">紹介動画</h2>

                <ul class="step-list">
                    <li class="step-item">
                        <h3 id="info03-01" class="step-h3">ヤギッシュの使いかた</h3>
                        <div class="step-movie">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/OeJnU_F8RX8?si=FM34OOr53fQWfyYw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                    </li>
                    <li class="step-item">
                        <h3 id="info03-02" class="step-h3">コンビニ印刷の仕方</h3>
                        <div class="step-movie">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/AyQVRGi_JrQ?si=8rZllOiChLPWbkT6" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                    </li>
                    <li class="step-item">
                        <h3 id="info03-03" class="step-h3">ヤギオファーについて</h3>
                        <div class="step-movie">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/_0iF2ZAPqGg?si=5lvTS3ysNvUWW9mX" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                    </li>
                </ul>
            </div>
        </section>

    </div>
</div>
</template>
<style lang="css" src="@/assets/css/renew_info.css"></style>

<style lang="scss" scoped>
    #info24 .caption {
        text-align: center;
        background: #0f9934;
        padding: 50px 16px;
        color: #fff;
        font-weight: 700;
        font-size: 1.5em;
        line-height: 1.2em;
    }

    #info24 .content-wrapper {
        width: 100%;
        text-align: left;
        padding: 0 10px;
        counter-reset: number 0;
    }

    #info24 .info-cream {
        padding: 20px 10px;
        background: #EDF5E8;
    }

    #info24 .flex {
        justify-content: space-between;
        flex-wrap: wrap;
        padding-top: 0;
        padding-bottom: 0;
    }

    #info24 .index-title {
        width: 100%;
        margin-bottom: 20px;
    }

    #info24 .index-item {
        position: relative;
        margin-left: 20px;
    }

    #info24 .index-title02 {
        margin-bottom: 10px;
    }

    #info24 .index-item::before {
        position: absolute;
        content: "";
        width: 7px;
        height: 7px;
        border: 0;
        border-bottom: solid 2px #0f9934;
        border-right: solid 2px #0f9934;
        transform: rotate(45deg);
        position: absolute;
        top: 0;
        left: -15px;
        bottom: 0;
        margin: auto;
    }

    #info24 .index-outlink::before {
        transform: rotate(-45deg);
    }

    #info24 .step-h2 {
        margin-bottom: 20px;
        font-size: 1.2rem;
        font-weight: bold;
        color: #0f9934;
        text-align: left;
    }

    #info24 .step-h3 {
        margin-bottom: 10px;
        margin-top: 50px;
        font-size: 1rem;
        font-weight: bold;
        color: #0f9934;
        text-align: left;
    }

    #info24 .step-h3 span {
        font-size: 0.8rem;
    }

    #info24 .red-note {
        color: #E3165C;
        font-weight: bold;
    }

    #info24 .info24-wrapper {
        margin-bottom: 100px;
    }

    #info24 .step-box {
        padding: 50px 10px 0;
    }

    #info24 .step-item {
        margin-bottom: 50px;
    }

    #info24 .step-lead {
        position: relative;
        font-size: 1rem;
        font-weight: bold;
        color: #004D40;
        padding-left: 60px;
    }

    #info24 .step-lead::before {
        position: absolute;
        counter-increment: number 1;
        content: "STEP" counter(number) " ";
        color: #0f9934;
        left: 0;
    }

    #info24 .step-img {
        display: block;
        margin: 10px auto;
        border: 1px solid #eee;
        width: 360px;
        max-width: 70%;
    }

    #info24 .step-txt {
        margin: 10px auto 20px;
    }

    #info24 .step-link {
        display: flex;
        justify-content: center;
        background: #404040;
        color: #fff;
        font-weight: bold;
        padding: 15px;
        border-radius: 50px;
        width: 250px;
        margin: 20px auto;
        border: 2px solid #404040;
    }

    #info24 .step-link:hover{
        opacity: 1;
        text-decoration: none;
        border: 2px solid #404040;
        background: #fff;
        color: #404040;
    }

    #info24 .step-movie{
        width: 100%;
        aspect-ratio: 16 / 9;
    }

    #info24 .step-movie iframe{
        width: 100%;
        height: 100%;
        border: 1px solid #eee;
    }

    @media screen and (min-width: 481px) {
        #info24 .content-wrapper {
            width: 750px;
        }

        #info24 .index-title {
            width: 50%;
        }
    }
</style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () {}
}
</script>
